import React, {useState, useEffect, forwardRef} from "react";
import {Autocomplete, Chip, TextField, Button, Container, Typography} from "@mui/material";
import {FixedSizeList} from "react-window";
import {connect} from "react-redux";
import {deliveryOrderSave, getAllOrders, getAllOrdersNotOrdered, messageReset} from "../store/orders";
import {getAllVerifyResponse} from "../store/logIn";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import {toast, ToastContainer} from "react-toastify";
import {useNavigate} from "react-router-dom";


const ListboxComponent = forwardRef((props, ref) => {
    const { children, ...other } = props;
    const itemCount = Array.isArray(children) ? children.length : 0;

    return (
        <div ref={ref} {...other}>
            <FixedSizeList
                height={300} // 🔹 Aniq balandlik berish kerak
                width="100%"
                itemSize={40} // 🔹 Har bir qator balandligi
                itemCount={itemCount}
            >
                {({ index, style }) => <div style={style}>{children[index]}</div>}
            </FixedSizeList>
        </div>
    );
});

const VirtualizedAutocomplete = ({ options, value, onChange }) => {
    return (
        <Autocomplete
            multiple
            options={options}
            getOptionLabel={(option) => option.code}
            value={value}
            onChange={(_, newValue) => onChange(newValue)}
            renderTags={(selected, getTagProps) =>
                selected.map((option, index) => (
                    <Chip key={option.id} label={option.code+'-'+option.serial_number} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => <TextField {...params} label="Tanlang" placeholder="Buyurtmalarni qidiring..." />}
            renderOption={(props, option) => <li {...props} key={option.id}>{option.code} - {option.serial_number}</li>}
            ListboxComponent={ListboxComponent} // 🔹 Virtualized List ishlaydi
            sx={{ width: "100%" }}
        />
    );
};

const Delivery = (props) => {
    const navigate = useNavigate()
    const [orders, setOrders] = useState([]); // Bazadan kelayotgan ma'lumot
    const [selectedOrders, setSelectedOrders] = useState([]); // Tanlangan buyurtmalar

    useEffect(() => {
        props.getAllOrdersNotOrdered()
    }, []);

    useEffect(() => {
        setOrders(props.orders)
    }, [props]);

    useEffect(() => {
        if (props.message === true) {
            navigate('/orders/')
        } else if (props.message === 'error') {
            toast.error('Xatolik!', {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    const handleSubmit = async () => {
        const selectedIds = selectedOrders.map((order) => order.id);
        if (selectedIds.length === 0){
            toast.error("Xatolik! Hech qanday buyurtmani tanlamadingiz!", {theme: 'colored'})
        }else{
            var obj = {
                "orders": selectedIds,
            }
            props.deliveryOrderSave(obj)
        }
    };

    return <div>
        <div className={'page worker-page serial_numbers'}>
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <div className={'header-page'}>
                        <h2 className={'page-title'}>{"Buyurtmalarni olib ketish yoki yetkazib berish"}</h2>
                    </div>
                    <Container maxWidth="md" sx={{ mt: 5 }}>
                        <Typography variant="h4" gutterBottom>
                            🚚 Buyurtmalarni tanlash
                        </Typography>
                        <VirtualizedAutocomplete options={orders} value={selectedOrders} onChange={setSelectedOrders} />
                        <Button variant="contained" color="primary" onClick={handleSubmit} sx={{ mt: 3, padding: 2 }}>
                            Tanlanganlarni skladdan chiqib ketganini tasdiqlash
                        </Button>
                    </Container>
                </div>
            </Box>
        </div>
        <ToastContainer/>
    </div>
};

export default connect(props => props.orders, {getAllOrdersNotOrdered, deliveryOrderSave, messageReset})(Delivery)